import { render } from "./WmsLayout.vue?vue&type=template&id=a525bf20&scoped=true&ts=true"
import script from "./WmsLayout.vue?vue&type=script&lang=ts"
export * from "./WmsLayout.vue?vue&type=script&lang=ts"

import "./WmsLayout.vue?vue&type=style&index=0&id=a525bf20&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a525bf20"]])

export default __exports__